import EventMonthTable from './EventMonthTable';
import { startOfWeek } from '../../date/DateHelpers';
import DateFormatter from '../../date/EventListingDateFormatter';
import RangeFormatter from '../../date/EventListingRangeFormatter';

class EventWeekTable extends EventMonthTable {

  constructor() {
    super();
    this.resultsFormatter = RangeFormatter.weekRange;
    this.thFormatter = DateFormatter.weekdayDate;
  }

  getWeeksStructure(date) {
    const weeks = super.getWeeksStructure(date);
    const dateTime = startOfWeek(date).getTime();

    return weeks.filter(week => startOfWeek(week[0].date).getTime() === dateTime);
  }
}

export default EventWeekTable;
